import React, { useCallback } from 'react'
import { AppToggle } from '../../../components/AppToggle'
import { useAppDispatch, useAppSelector } from '../../../core/store/store'
import {
  setButtonScrollMode,
  setKeyboardMode,
} from '../../../core/store/options/optionsSlice'
import { TextWithLabel } from '../../../components/TextWithLabel'
import { useGetVersionsQuery } from '../../../core/api/VersionsApi'
import version from '../../../version.json'
import { useTranslation } from 'react-i18next'
import { LanguageSwitcherDropdown } from 'shared/ui/LanguageSwitcherDropdown/LanguageSwitcherDropdown'

export enum DetailTab {
  'main' = 'main',
  'info' = 'info',
}

export const MainTab = () => {
  const { t } = useTranslation()
  const { buttonScrollMode, keyboardMode } = useAppSelector(
    (state) => state.options,
  )
  const { data: versions } = useGetVersionsQuery(null)

  const dispatch = useAppDispatch()

  const changeButtonModeScroll = useCallback(
    (value: boolean) => {
      dispatch(setButtonScrollMode({ buttonMode: value }))
    },
    [dispatch],
  )

  const changeKeyboardMode = useCallback(
    (value: boolean) => {
      dispatch(setKeyboardMode({ keyboardMode: value }))
    },
    [dispatch],
  )

  return (
    <React.Fragment>
      <div className="width-for-page-wrapper">
        {/* <AppTitlePage title="Настройки" /> */}
        <div className="option-page-card mt-20">
          <div className="option-page-item">
            <div className="ico-block">
              <i className="an-ico an-ico-keyboard-2" />
            </div>
            <div className="item">
              <span>{t('Клавиатура Фотобокс')}</span>
              <AppToggle value={keyboardMode} onChange={changeKeyboardMode} />
            </div>
          </div>
          <div className="option-page-item">
            <div className="ico-block">
              <i className="an-ico an-ico-aim" />
            </div>
            <div className="item">
              <span>{t('Кнопки пролистывания')}</span>
              <AppToggle
                value={buttonScrollMode}
                onChange={changeButtonModeScroll}
              />
            </div>
          </div>

          <LanguageSwitcherDropdown />
          <div className="option-page-item">
            <TextWithLabel
              label="Версия"
              text={`Frontend: ${version.version || '---'}<br/> Backend: ${
                versions?.backendVersion || '---'
              }<br/> Sensor server: ${'---'}
              <br/> AI: ${versions?.serviceAiVersion || '---'} `}
            />
            {/*    <TextWithLabel
              label="Версия"
              text={`Frontend: ${
                versions?.frontendVersion || version.version || '---'
              }<br/> Backend: ${
                versions?.backendVersion || '---'
              }<br/> Sensor server: ${versions?.serviceSensorVersion || '---'}
              <br/> AI: ${versions?.serviceAiVersion || '---'}`}
            /> */}
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}
